"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CustomFeaturedCollection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomFeaturedCollection, _HTMLElement);
  function CustomFeaturedCollection() {
    _classCallCheck(this, CustomFeaturedCollection);
    return _callSuper(this, CustomFeaturedCollection);
  }
  _createClass(CustomFeaturedCollection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.target = this.querySelector(".swiper");
      this.initSwiper();
      this.initialColorSwatch();
      this.initialNavigateToProductPage();
      this.resizeObserver = new ResizeObserver(function (entries) {
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var entry = _step.value;
            if (entry.contentBoxSize[0]) {
              var width = entry.contentBoxSize[0].inlineSize;
              var num = 2;
              _this.style = "--swiper-navigation-top-offset: 34%";
              if (width >= 1240) {
                num = 5;
                _this.style = "--swiper-navigation-top-offset: 40%";
              } else if (width >= 750) {
                num = 3;
                _this.style = "--swiper-navigation-top-offset: 40%";
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      this.resizeObserver.observe(this.target);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.resizeObserver.unobserve(this.target);
    }
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var _this2 = this;
      var swiper = new Swiper(this.target, {
        loop: false,
        direction: "horizontal",
        slidesPerView: 2,
        spaceBetween: 4,
        mousewheel: {
          enabled: false,
          releaseOnEdges: true
        },
        breakpoints: {
          750: {
            slidesPerView: 4
          },
          1240: {
            slidesPerView: 5
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function init() {
            _this2.target.classList.add("swiper-initialized");
          }
        }
      });
    }
  }, {
    key: "initialColorSwatch",
    value: function initialColorSwatch() {
      console.log("initial color swatch");
      var colorSwatches = this.querySelectorAll(".color-item");
      colorSwatches.forEach(function (swatch) {
        swatch.addEventListener("click", function (e) {
          e.preventDefault();
          var parent = swatch.closest(".custom-card-product");
          var mainCover = swatch.getAttribute("data-main-cover");
          var secondaryCover = swatch.getAttribute("data-secondary-cover");
          var url = swatch.getAttribute("data-url");
          parent.querySelector(".product-cover").setAttribute("data-href", url);
          parent.querySelector(".main-cover").src = mainCover;
          parent.querySelector(".secondary-cover").src = secondaryCover;
          parent.querySelectorAll(".color-item").forEach(function (item) {
            item.classList.remove("active");
          });
          swatch.classList.add("active");
        });
      });
    }
  }, {
    key: "initialNavigateToProductPage",
    value: function initialNavigateToProductPage() {
      var productCovers = this.querySelectorAll(".product-cover");
      productCovers.forEach(function (cover) {
        cover.addEventListener("click", function () {
          var url = cover.getAttribute("data-href");
          if (url) {
            window.location.href = url;
          }
        });
      });
    }
  }]);
  return CustomFeaturedCollection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("custom-featured-collection")) {
  customElements.define("custom-featured-collection", CustomFeaturedCollection);
}